import script from "./appbar.vue?vue&type=script&setup=true&lang=js"
export * from "./appbar.vue?vue&type=script&setup=true&lang=js"

import "./appbar.vue?vue&type=style&index=0&id=c555c084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c555c084"]])

export default __exports__